// dynamicGlobalTime.jsx
import { useState, useRef, useEffect } from "react";

export function useDynamicGlobalTime(
  initialPlaybackSpeed = 1, 
  startTimestamp = 0
) {
  // 一度だけ startTimestamp を記録し、以降は上書きしない
  const initialStartRef = useRef(startTimestamp);

  // 現在の「シミュレーション上の時間」（秒）
  const [currentTime, setCurrentTime] = useState(initialStartRef.current);

  // 再生速度を ref で管理
  const playbackSpeedRef = useRef(initialPlaybackSpeed);

  // 前回の実時間を保存しておく
  const lastRealTimeRef = useRef(performance.now());

  // 例: 24時間で 0 に戻したい場合
  const maxTime = 60 * 60 * 24;

  // アニメーションループはコンポーネントマウント時に一度だけセット
  useEffect(() => {
    let animationId;

    const updateTime = () => {
      // 今の実時間
      const now = performance.now();
      // 前回からの実時間差(ミリ秒 → 秒)
      const deltaSec = (now - lastRealTimeRef.current) / 1000;

      // 今回を「次のフレームのための前回」として保存
      lastRealTimeRef.current = now;

      // deltaSec × 現在の playbackSpeed だけ進める
      setCurrentTime((prevTime) => {
        const newTime = prevTime + deltaSec * playbackSpeedRef.current;
        return newTime % maxTime; // 24時間でラップ
      });

      // ループ継続
      animationId = requestAnimationFrame(updateTime);
    };

    // ループ開始
    animationId = requestAnimationFrame(updateTime);

    // クリーンアップ
    return () => {
      cancelAnimationFrame(animationId);
    };
  }, []); // 依存配列は空

  // playbackSpeed が変化したら ref を更新
  useEffect(() => {
    playbackSpeedRef.current = initialPlaybackSpeed;
  }, [initialPlaybackSpeed]);

  return currentTime;
}

export default useDynamicGlobalTime;
